import * as tslib_1 from "tslib";
/** @jsx withSlots */
import { withSlots, getSlots } from '../../Foundation';
import { getNativeProps, htmlElementProperties } from '../../Utilities';
export var TextView = function (props) {
    if (!props.children) {
        return null;
    }
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = tslib_1.__rest(props, ["block", "className", "as", "variant", "nowrap"]);
    var Slots = getSlots(props, {
        root: RootType
    });
    return withSlots(Slots.root, tslib_1.__assign({}, getNativeProps(rest, htmlElementProperties)));
};
//# sourceMappingURL=Text.view.js.map